export const VDI_TRANSACTION_TEST_IDS = {
  PAGE: 'vdi-transaction-page',
  AUTO_REFRESH_TOGGLE: 'vdi-transaction-auto-refresh-toggle',
  SEARCH_INPUT: 'vdi-transaction-search-input',
  FILTER_DROPDOWN: 'vdi-transaction-filter-dropdown',
  TYPE_FILTER: 'vdi-transaction-type-filter',
  STATUS_FILTER: 'vdi-transaction-status-filter',
  VERSION_SELECT: 'vdi-transaction-version-select',
  TABLE: 'vdi-transaction-table',
  TABLE_ROW: (id: string) => `vdi-transaction-table-row-${id}`,
  COL_VDI_REQUEST_ID: (id: string) =>
    `vdi-transaction-col-vdi-request-id-${id}`,
  COL_OPERATOR_INFO: (id: string) => `vdi-transaction-col-operator-info-${id}`,
  COL_TYPE: (id: string) => `vdi-transaction-col-type-${id}`,
  COL_STATUS_CODE: (id: string) => `vdi-transaction-col-status-code-${id}`,
  COL_TRANSACTION_DATE: (id: string) =>
    `vdi-transaction-col-transaction-date-${id}`,
  COL_CREATED_ON: (id: string) => `vdi-transaction-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `vdi-transaction-col-updated-on-${id}`,
  COL_REQUEST_STATUS: (id: string) =>
    `vdi-transaction-col-request-status-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'vdi-transaction-expanded-panel',
  EXPANDED_STEPPER: 'vdi-transaction-expanded-stepper',
  EXPANDED_ERRORS: 'vdi-transaction-expanded-errors',
  EXPANDED_PAYLOAD: 'vdi-transaction-expanded-payload',
} as const;
